import React from 'react';
import classes from '../../utils/styles/Loader.module.css';

const Loader = ({ message = "Loading..." }) => (
  <div className={classes.Loader} role="status" aria-live="polite">
    <div className={classes.Spinner}></div>
    <span className={classes.Message}>{message}</span>
  </div>
);

export default Loader;
